import React from 'react';

export enum SustainabilityBadgeSlots {
  slotSuggestCollectionPoint = 'slot_suggest_collection_point',
  slotOptionCollectionPoint = 'slot_option_collection_point',
  slotOptionHomeDelivery = 'slot_option_home_delivery',
}

export const SustainabilityBadgeSlot: React.FC<{
  slotName: SustainabilityBadgeSlots;
  badgeText?: string;
  onBadgeClick?: VoidFunction;
  classNames: string;
  testId?: string;
  leafIcon?: React.ReactNode;
  infoIcon?: React.ReactNode;
}> = ({
  slotName,
  badgeText,
  onBadgeClick,
  classNames,
  testId,
  infoIcon,
  leafIcon,
}) => {
  return (
    <div
      className={classNames}
      data-testid={testId}
      slot={slotName}
      onClick={e => {
        e.currentTarget.dispatchEvent(
          new CustomEvent(slotName, {
            bubbles: true,
            composed: true,
          }),
        );
      }}
    >
      <div
        className="badge"
        onClick={e => {
          if (onBadgeClick) {
            e.stopPropagation();
            onBadgeClick();
          }
        }}
      >
        {leafIcon && <>{leafIcon}</>}
        {badgeText && (
          <p
            className={`sustainabilityText ${
              slotName === SustainabilityBadgeSlots.slotSuggestCollectionPoint
                ? 'slotSuggestCollectionPoint'
                : ''
            }`}
            dangerouslySetInnerHTML={{
              __html: badgeText,
            }}
          />
        )}
      </div>
      {infoIcon && <>{infoIcon}</>}
    </div>
  );
};
